export default "__VITE_ASSET__CAMpmeo5__"